import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { InnerBlocks, getColorClassName } from '@wordpress/block-editor';
export default function save(_ref) {
  var attributes = _ref.attributes;
  var backgroundColor = attributes.backgroundColor,
      customBackgroundColor = attributes.customBackgroundColor;
  var backgroundClass = getColorClassName('background-color', backgroundColor);
  var className = classnames(backgroundClass, {
    'has-background': backgroundColor || customBackgroundColor
  });
  var styles = {
    backgroundColor: backgroundClass ? undefined : customBackgroundColor
  };
  return createElement("div", {
    className: className,
    style: styles
  }, createElement("div", {
    className: "wp-block-group__inner-container"
  }, createElement(InnerBlocks.Content, null)));
}
//# sourceMappingURL=save.js.map